import { c as _c } from "react/compiler-runtime";
import { useCouponId, useCouponPrice } from '@svenskaspelab/poolbetting/core/frameworks/nextjs/coupon';
import type { CouponIndex } from '@svenskaspelab/poolbetting/schema/coupon';
type CouponsOverviewTabsLabelProps = {
  couponIndex: CouponIndex;
};

/**
 * Renders the label for the coupon overview tabs.
 *
 * @param param0 Props object
 * @param param0.couponIndex The index of the coupon to be displayed in the tab label.
 * @returns The label string for the coupon tab.
 */
export default function CouponsOverviewTabsLabel(t0) {
  const $ = _c(3);
  const {
    couponIndex
  } = t0;
  const [couponId] = useCouponId();
  let t1;
  if ($[0] !== couponId || $[1] !== couponIndex) {
    t1 = {
      couponId,
      couponIndex
    };
    $[0] = couponId;
    $[1] = couponIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const price = useCouponPrice(t1);
  return `${couponIndex + 1} - ${price} kr`;
}